import React, { Component } from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ROCrossSellingReport from "./component/roCrossSellingReport";
import ROYearToDateH1Report from "./component/roYearToDateH1Report";
import ROYearToDateH23Report from "./component/roYearToDateH23Report";
import ROYearToDateXSH21Report from "./component/roYearToDateXSH21Report";
import ROYearToDateXSH21PReport from "./component/roYearToDateXSH21PReport";
import { connect } from "react-redux";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import Container from "../../../../../modules/commons/Container";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { mapToObjectDDL } from "../../../../common/mapper";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../../common/Constants";

class ProspectMonitoringRO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isAllSelected: false,
            isSpecificSelected: false,
            month: null,
            year: null,
            dataCabang: [],
            kodeCabang: [],
            search: [],
            loading: false,
        };
    };

    componentDidMount = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
        }));
        await this.fetchDataCabang();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (R.isNil(this.state.kodeCabang)) {
            this.setState((prevValue) => ({
                ...prevValue,
                kodeCabang: [],
            }));
        }
        if (!R.equals(prevState.doSearch, this.state.doSearch)) {
            console.log("doSearch", this.state.doSearch);
        }
    };

    handleChangeDoSearch = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            doSearch: value,
        }));
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            setError: this.props.setError,
            menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Cabang",
            args: null,
        });

        if (res.data.status === HttpStatus.SUCCESS) {

            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );
            console.log(filteredData);

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: filteredData,
                }));
            }
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
    };

    handleSelectCabang = (e, type) => {
        const isChecked = e.target.checked;

        if (type === "ALL") {
            this.setState((prevValue) => ({
                ...prevValue,
                isAllSelected: isChecked,
                isSpecificSelected: false,
                kodeCabang: [],
            }));
        }

        if (type === "SPECIFIC") {
            this.setState((prevValue) => ({
                ...prevValue,
                isSpecificSelected: isChecked,
                isAllSelected: false,
                kodeCabang: [],
            }));
        }
    };

    handleSearch = () => {
        const { dataCabang, kodeCabang, isAllSelected, isSpecificSelected } = this.state;

        const kodeCabangList = isAllSelected
            ? dataCabang.map(item => item.kodeCabang)
            : isSpecificSelected && kodeCabang?.length
                ? kodeCabang.map(item => item.value)
                : [];

        this.setState(prev => ({
            ...prev,
            doSearch: true,
            search: kodeCabangList
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prev) => ({ ...prev, loading: !prev.loading }))
    }

    handleChangeCabang = (value) => {
        this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{ gap: "20px", alignItems: "center" }}>
                        <SimpleCheckBox
                            id="reportAllCabang"
                            key="reportAllCabang"
                            name="reportAllCabang"
                            label="ALL CABANG"
                            checked={this.state.isAllSelected}
                            onChange={(e) => this.handleSelectCabang(e, "ALL")}
                        />
                        <SimpleCheckBox
                            id="reportSpecificCabang"
                            key="reportSpecificCabang"
                            name="reportSpecificCabang"
                            label="SPESIFIK CABANG"
                            checked={this.state.isSpecificSelected}
                            onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
                        />
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="multiselect"
                            name="kodeCabang"
                            isClearable
                            containerclassname="width width-500px margin-top-15px"
                            placeholder="Nama Cabang"
                            readOnly={!this.state.isSpecificSelected}
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value) => this.handleChangeCabang(value)}
                        />
                        <SimpleButton onClick={() => this.handleSearch()}>Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Laporan Statistik Repeat Order dan Cross Selling</Tab>
                            <Tab>Laporan Statistik Repeat Order H1 per Cabang Year To Date</Tab>
                            <Tab>Laporan Statistik Repeat Order H23 per Cabang Year To Date</Tab>
                            <Tab>Laporan Statistik Repeat Order XS H21 per Cabang Year To Date</Tab>
                            <Tab>Laporan Statistik Repeat Order XS H21P per Cabang Year To Date</Tab>
                        </TabList>
                        <TabPanel>
                            <ROCrossSellingReport
                                search={this.state.search}
                                isAllSelected={this.state.isAllSelected}
                                dataCabang={this.state.dataCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ROYearToDateH1Report
                                search={this.state.search}
                                isAllSelected={this.state.isAllSelected}
                                dataCabang={this.state.dataCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ROYearToDateH23Report
                                search={this.state.search}
                                isAllSelected={this.state.isAllSelected}
                                dataCabang={this.state.dataCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ROYearToDateXSH21Report
                                search={this.state.search}
                                isAllSelected={this.state.isAllSelected}
                                dataCabang={this.state.dataCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ROYearToDateXSH21PReport
                                search={this.state.search}
                                isAllSelected={this.state.isAllSelected}
                                dataCabang={this.state.dataCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                    {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
                </Container>
            </>
        );
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(null, mapDispatchToProps)(ProspectMonitoringRO);